<template>
    <!-- Sidebar component, swap this element with another sidebar if you like -->
    <nav class="flex flex-col flex-1 px-2 bg-white">
        <div v-if="wizardPercentage" class="justify-center mt-2 flex">
            <wizard-completion-circle :percentage="wizardPercentage">

            </wizard-completion-circle>
        </div>
        <!--             TODO: not first gets mt-1-->
        <div    v-if="showSonicuSidebar && (permissions.isSonicu() || permissions.isSonicuViewOnly())">
            <sonicu-sidebar     :network-maintenance-enabled="networkMaintenanceEnabled"
            ></sonicu-sidebar>
        </div>


        <a :href="link.target"
           v-for="(link, index) in links"
           :class="link.active ? 'hover:text-gray-900 hover:bg-gray-100 focus:text-gray-900 focus:bg-gray-100 focus:no-underline text-gray-900 bg-gray-100' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50 focus:text-gray-900 focus:bg-gray-100 focus:no-underline'"
           class="group grid grid-cols-6 gap-x-2 plain-link items-center px-3 py-2 text-sm leading-5 font-medium rounded-md focus:outline-none">
            <a :href="company.buildCompanyRoute('alarms', company.getCompanyId(defaultCompany))"
               class="hover:text-gray-900 focus:text-gray-900 text-gray-900 focus:no-underline"
               v-if="link.areaId && areas[link.areaId] > 0">
                <span class="lnr icon-alarm2"></span>
            </a>

            <span v-else-if="link.iconLeft"
                    :class="link.iconLeft"
                    class="col-span-1 lnr"></span>
            <span v-else
                  class="col-span-1"></span>

            <span class="my-1 col-span-4 flex space-x-2 items-center">
                <span>
                    {{link.text}}
                </span>

            <div v-if="link.ignored && permissions.isSonicu()" class="relative flex h-4 w-4 items-center justify-center rounded bg-gray-300 text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eye-closed group">
                        <title>Area is excluded</title>
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4" />
                        <path d="M3 15l2.5 -3.8" />
                        <path d="M21 14.976l-2.492 -3.776" />
                        <path d="M9 17l.5 -4" />
                        <path d="M15 17l-.5 -4" />
                    </svg>
                </div>
            </span>


            <span v-if="link.iconRight"
                  :class="link.active ? iconRightActiveClass : iconRightInactiveClass"
                  class="col-span-1 ml-auto inline-block py-0.5 px-2 text-xs leading-4 rounded-full bg-white">
                <span class="lnr icon-checkmark-circle text-green-600"></span>
            </span>
            <span v-else-if="areas[link.areaId] > 0"
                  class="col-span-1 ml-auto inline-block py-0.5 px-2 text-xs leading-4 rounded-full bg-red-200">
                <span class="text-gray-900">{{areas[link.areaId]}}</span>
            </span>
            <span v-else
                  class="col-span-1"></span>
        </a>

      <div v-if="bottomLinks.length > 0" class="grow flex flex-col justify-end">

          <div  v-if="environment.isLocal()"
                class="mx-2">
              <div  class="text-md text-gray-800">
                  Local Testing
              </div>
              <feature-level-sidebar></feature-level-sidebar>
          </div>

          <div class="-mx-2 border-t mb-2"></div>

          <a v-if="healthScore"
             :href="'/nova/resources/health-scores/' + healthScore.id"
             class="grid grid-cols-6 items-center gap-x-2 rounded-md px-3 py-2 text-sm font-medium leading-5 group plain-link focus:outline-none hover:bg-gray-100 focus:text-gray-900 focus:bg-gray-100 focus:no-underline">

            <span class="col-span-1 lnr icon-first-aid"></span>

            <span class="col-span-4 my-1">Health Score</span>

            <div v-if="healthScore.score < 20" v-on:mouseover="toggleToolTip" v-on:mouseleave="toggleToolTip" class="lnr icon-check !text-base bg-green-200 text-green-950 rounded-full h-7 w-7 flex justify-center items-center relative">
              <div v-if="toolTipVisible" class="absolute top-0 left-7 -translate-x-full -translate-y-full z-20 pb-2 w-max -mr-20">
                <span class="bg-gray-100 shadow-md rounded-md py-1 px-2 w-full text-gray-900 flex flex-col max-w-48 font-sans">
                  <span class="block">
                    Score: {{ healthScore.score }}
                  </span>
                  <span class="block">
                    Score Date: {{ healthScore.score_date }}
                  </span>
                  <span class="block">
                    Last Review: {{ healthScore.company_last_reviewed_at_human_diff }}
                  </span>
                </span>
              </div>
            </div>

            <div v-if="healthScore.score >= 20 && healthScore.score < 80" v-on:mouseover="toggleToolTip" v-on:mouseleave="toggleToolTip" class="lnr icon-question !text-sm bg-yellow-100 text-yellow-950 rounded-full h-7 w-7 flex justify-center items-center relative">
              <div v-if="toolTipVisible" class="absolute top-0 left-7 -translate-x-full -translate-y-full z-20 pb-2 w-max -mr-20">
                <span class="bg-gray-100 shadow-md rounded-md py-1 px-2 w-full text-gray-900 flex flex-col max-w-48 font-sans">
                  <span class="block">
                    Score: {{ healthScore.score }}
                  </span>
                  <span class="block">
                    Score Date: {{ healthScore.score_date }}
                  </span>
                  <span class="block">
                    Last Review: {{ healthScore.company_last_reviewed_at_human_diff }}
                  </span>
                </span>
              </div>
            </div>

            <div v-if="healthScore.score > 80" v-on:mouseover="toggleToolTip" v-on:mouseleave="toggleToolTip" class="lnr icon-exclamation !text-base bg-red-200 text-red-950 rounded-full h-7 w-7 flex justify-center items-center relative">
              <div v-if="toolTipVisible" class="absolute top-0 left-7 -translate-x-full -translate-y-full z-20 pb-2 w-max -mr-20">
                <span class="bg-gray-100 shadow-md rounded-md py-1 px-2 w-full text-gray-900 flex flex-col max-w-48 font-sans">
                  <span class="block">
                    Score: {{ healthScore.score }}
                  </span>
                  <span class="block">
                    Score Date: {{ healthScore.score_date }}
                  </span>
                  <span class="block">
                    Last Review: {{ healthScore.company_last_reviewed_at_human_diff }}
                  </span>
                </span>
              </div>
            </div>
          </a>

          <div v-if="earliestDateLimitDays > 0"
               class="grid grid-cols-6 items-center gap-x-2 rounded-md px-3 py-2 text-sm font-medium leading-5 text-gray-600">
            <span class="col-span-1 lnr icon-calendar-full"></span>
            <span class="col-span-5 my-1">Data Limited to {{ earliestDateLimitDays }} Days</span>
          </div>

          <a :href="link.target"
             v-for="(link, index) in bottomLinks"
             :class="link.active ? 'hover:text-gray-900 hover:bg-gray-100 focus:text-gray-900 focus:bg-gray-100 focus:no-underline text-gray-900 bg-gray-100' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50 focus:text-gray-900 focus:bg-gray-100 focus:no-underline'"
             class="group grid grid-cols-6 gap-x-2 plain-link items-center px-3 py-2 text-sm leading-5 font-medium rounded-md focus:outline-none">
            <a :href="company.buildCompanyRoute('alarms', company.getCompanyId(defaultCompany))"
               class="hover:text-gray-900 focus:text-gray-900 text-gray-900 focus:no-underline"
               v-if="link.areaId && areas[link.areaId] > 0">
              <span class="lnr icon-alarm2"></span>
            </a>

            <span v-else-if="link.iconLeft"
                  :class="link.iconLeft"
                  class="col-span-1 lnr"></span>
            <span v-else
                  class="col-span-1"></span>

            <span class="my-1 col-span-4">
              {{link.text}}
            </span>


            <span v-if="link.iconRight"
                  :class="link.active ? iconRightActiveClass : iconRightInactiveClass"
                  class="col-span-1 ml-auto inline-block py-0.5 px-2 text-xs leading-4 rounded-full bg-white">
              <span class="lnr icon-checkmark-circle text-green-600"></span>
            </span>
            <span v-else-if="areas[link.areaId] > 0"
                  class="col-span-1 ml-auto inline-block py-0.5 px-2 text-xs leading-4 rounded-full bg-red-200">
              <span class="text-gray-900">{{areas[link.areaId]}}</span>
            </span>
            <span v-else
                  class="col-span-1"></span>
          </a>
      </div>
    </nav>
</template>

<script>
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    import axios from 'axios';
    import WizardCompletionCircle from "@/components/InstallWizard/WizardCompletionCircle";
    import SonicuSidebar from "@/components/SonicuSidebar/SonicuSidebar.vue";
    import FeatureLevelSelection from "./sidebar/FeatureLevelSelection.vue";
    import FeatureLevelSidebar from "./sidebar/FeatureLevelSidebar.vue";

    export default {
        name: "sidebar",
        components: {FeatureLevelSidebar, FeatureLevelSelection, SonicuSidebar, WizardCompletionCircle},
        mixins: [SonicuCoreMixin],
        data() {
            return {
                areas: {},
                iconRightActiveClass: 'bg-white',
                iconRightInactiveClass: 'bg-gray-100 group-hover:bg-gray-200 group-focus:bg-gray-200',
                toolTipVisible: false
            }
        },
        props: {
            links: Array,
            bottomLinks: Array,
            healthScore: Object,
            wizardPercentage: null,
            defaultCompany: String,
            showSonicuSidebar: Boolean,
            networkMaintenanceEnabled: Boolean,
            earliestDateLimitDays: Number,
        },
        mounted() {
            if (this.shouldCheckAlarms()) {
                this.countAlarmsOnArea();
            }

        },
        methods: {
            countAlarmsOnArea(){
                let url = this.company.buildCompanyApiInternalRoute('alarms/count', this.company.getCompanyId(this.defaultCompany))
                axios.get(url)
                    .then(response => {
                        this.areas = response.data;
                    });
            },
            shouldCheckAlarms() {
                let checkAlarms = false
                this.links.forEach(value => {
                    if (value.areaId !== null) {
                        checkAlarms = true
                    }
                })
                return checkAlarms
            },
            toggleToolTip() {
              let timeout = 250;

              if (this.toolTipVisible) {
                timeout = 0;
              }
              setTimeout(() => {
                this.toolTipVisible = !this.toolTipVisible;
              }, timeout)
            },

        }
    }
</script>

<style scoped>

</style>